import styled from 'styled-components';
import { Image as SemanticImage } from 'semantic-ui-react';

export const Image = styled(SemanticImage)`
  &.ui.image {
    max-height: 300px;
  }
`;
